var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:`nav nav-${_vm.pills ? 'pills' : ''}${_vm.tabs ? 'tabs' : ''} ${_vm.vertical ? 'flex-column' : ''} ${_vm.align ? 'justify-content-'+_vm.align : ''}`+' '+_vm.extraclass,attrs:{"id":_vm.id,"role":_vm.role,"aria-orientation":_vm.aria}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }